/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsOfUseReadModel
 */
export interface TermsOfUseReadModel {
    /**
     * 
     * @type {boolean}
     * @memberof TermsOfUseReadModel
     */
    hasUserApproved: boolean;
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseReadModel
     */
    termsOfUsePdfBase64: string;
}

/**
 * Check if a given object implements the TermsOfUseReadModel interface.
 */
export function instanceOfTermsOfUseReadModel(value: object): value is TermsOfUseReadModel {
    if (!('hasUserApproved' in value) || value['hasUserApproved'] === undefined) return false;
    if (!('termsOfUsePdfBase64' in value) || value['termsOfUsePdfBase64'] === undefined) return false;
    return true;
}

export function TermsOfUseReadModelFromJSON(json: any): TermsOfUseReadModel {
    return TermsOfUseReadModelFromJSONTyped(json, false);
}

export function TermsOfUseReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsOfUseReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'hasUserApproved': json['hasUserApproved'],
        'termsOfUsePdfBase64': json['termsOfUsePdfBase64'],
    };
}

export function TermsOfUseReadModelToJSON(json: any): TermsOfUseReadModel {
    return TermsOfUseReadModelToJSONTyped(json, false);
}

export function TermsOfUseReadModelToJSONTyped(value?: TermsOfUseReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasUserApproved': value['hasUserApproved'],
        'termsOfUsePdfBase64': value['termsOfUsePdfBase64'],
    };
}

